import axiosInstance from "../../axios";



export const state = {
    ticketsData: {},
    ticketsError: null,

    ticketsReplyData: {},
    ticketReply: null
}

export const mutations = {
    setTicketsData(state, data) {
        state.ticketsData = data;
    },

    setTicketsReplyData(state, data) {
        state.ticketsReplyData = data;
    },

    setTicketReply(state, data) {
        state.ticketReply = data;
    },

    setTicketsError(state, msg) {
        state.ticketsError = msg
    },
}

export const getters = {
    ticketsData: state => state.ticketsData,
    ticketsReplyData: state => state.ticketsReplyData,
    ticketReply: state => state.ticketReply,
    ticketsError: state => state.ticketsError,
}

export const actions = {

    async getTicketsData({ commit }) {
        try {
            const result = await axiosInstance({ requiresAuth: true }).get("/customer/tickets");

            commit('setTicketsData', result);
            commit("setTicketsError", null);
        } catch (error) {
            commit("setTicketsError", error.response.data.message);
            throw error;
        }
    },

    async getTicketsReplyData({ commit }) {
        try {
            const result = await axiosInstance({ requiresAuth: true }).get("/customer/reply-threads");

            commit('setTicketsReplyData', result.data.data);
            commit("setTicketsError", null);
        } catch (error) {
            commit("setTicketsError", error.response.data.message);
            throw error;
        }
    },


    async updateTicketStatus({ commit, dispatch }, payload) {
        const { id, newStatus } = payload;
        
        try {
            await axiosInstance({ requiresAuth: true }).patch(
                `/customer/reply-threads/${id}/update-status`,
                { status_id: newStatus }
            );

            await dispatch('getTicketsReplyData');
            commit("setTicketsError", null);
        } catch (error) {
            commit("setTicketsError", error.response?.data?.message || "An unknown error occurred.");
            throw error;
        }
    }, 
 

    async getTicketFile({ commit }, payload) {
        const { ticketId, fileId } = payload;
        try {
            const response = await axiosInstance({ requiresAuth: true }).get(
                `/customer/tickets/${ticketId}/files/${fileId}/download`,
                {
                    responseType: 'blob',
                }
            );
            commit("setTicketsError", null);
            return response;
        } catch (error) {
            commit("setTicketsError", error.response?.data?.message || "An unknown error occurred.");
            throw error;
        }
    },

    async getTicketReply({ commit }, id) {
        try {
            const result = await axiosInstance({ requiresAuth: true }).get(`/customer/tickets/${id}`);

            commit('setTicketReply', result);
            commit("setTicketsError", null);
        } catch (error) {
            commit("setTicketsError", error.response.data.message);
            throw error;
        }
    },
}



export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
